import { NavLink } from "react-router-dom";

export default function Ductlines() {
    return (
        <main>
            <nav>
                <NavLink to="/">Back</NavLink>
            </nav>
            <h1>Ductlines</h1>
        </main>
    )
}